import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import foodReducer from "../features/food/foodSlice";
import cartReducer from "../features/cart/cartSlice";


export const store = configureStore ({
  reducer :{
    auth : authReducer,
    food: foodReducer, 
    cart: cartReducer,
  },
});

